import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/header"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

export type GradientProps = {
    flip: boolean
    isShown: boolean
    isTouchDevice: boolean
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

export const Gradient = memo((props: GradientProps) => {
    const ComponentName = useTemplatedComponent(props.templating, MANIFEST)
    return (
        <Suspense>
            <ComponentName
                flip={props.flip}
                isShown={props.isShown}
                isTouchDevice={props.isTouchDevice}
                templating={props.templating}
            />
        </Suspense>
    )
})
Gradient.displayName = "Gradient"

export default connect(Gradient)
